<template>
  <Layout1>
    <Layout2 :ratio="'426px 1fr'" id="tagsSetting" >
      <template slot="left">
        <div class="tagslist">
          <div v-for="(tagS, t) in tags" :key="`tag-${t}`" :class="tagS.options===tagSelect?'selected':''" @click="tagSelect=tagS.options">
            <div class="tagname"><div class="num" :class="tagS.sum===0?'nan':''" @click.stop="deleteTag=tagS.sum===0?tagS.options:null" :num="tagS.sum"></div>{{tagS.options}}</div>
            <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="mask0_910_8128" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="9" height="16">
              <path d="M9.00001 0.5H0.245148V15.5H9.00001V0.5Z" fill="white"/>
              </mask>
              <g mask="url(#mask0_910_8128)">
              <path d="M8.8468 8.39372C8.85677 8.37451 8.87282 8.35821 8.88157 8.33827C9.05278 7.98224 8.9966 7.54644 8.69359 7.25996L1.82102 0.759722C1.44626 0.405393 0.855309 0.422417 0.500494 0.796444C0.146165 1.1712 0.162459 1.76215 0.537216 2.11697L6.7038 7.95038L0.561535 13.8704C0.190426 14.2283 0.179239 14.8193 0.537216 15.1909C0.720339 15.3816 0.964988 15.4766 1.20964 15.4766C1.4431 15.4766 1.67656 15.3893 1.85774 15.2152L8.66805 8.6515C8.68119 8.63837 8.68605 8.62037 8.69918 8.60675C8.70915 8.59751 8.71961 8.59046 8.72958 8.58073C8.7826 8.52504 8.81056 8.45719 8.8468 8.39372Z" fill="var(--color-pri)"/>
              </g>
            </svg>
          </div>
        </div>
        <div id="tags-foot">
          <button @click="addone=true">+新增群組標籤</button>
        </div>
      </template>
      <div class="titlea">
        <div>標籤人員名單</div>
        <RBtn @click="addmember=true" :bg="'var(--color-checked)'" :text="'新增人員'" :icon="'add'" :style="{padding: '20px'}"/>
        <RBtn @click="exporttofile" :text="'匯出'" :icon="'excel1'" :bg="'var(--color-pri)'" :style="{marginLeft: 'auto'}"/>
        <SBtn @click="$router.push({ name: 'push', query: { page: '指定推播', tag: tagSelect } })" :bg="'#9EAF89'" :text="'指定推播'" :icon="'push'" :iconSize="'25px'" :style="{height: '50px'}"/>
      </div>
      <div class="userList">
        <div v-for="user in users" :key="user._id">
          <div>{{user.lineName}} <span v-if="user.pause">(停用)</span></div>
          <button @click="removeOne(user._id)">
            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.5002 0C5.59644 0 0 5.59644 0 12.5002C0 19.4036 5.59644 25 12.5002 25C19.4036 25 25 19.4036 25 12.5002C24.9918 5.59999 19.4004 0.0081617 12.5002 0ZM12.5002 22.9841C6.70998 22.9841 2.01629 18.2904 2.01629 12.5002C2.01629 6.70998 6.70998 2.01629 12.5002 2.01629C18.29 2.01629 22.9841 6.70998 22.9841 12.5002C22.9773 18.2875 18.2875 22.9773 12.5002 22.9841ZM16.9912 8.00876C16.5977 7.61522 15.9593 7.61522 15.5658 8.00876L12.5002 11.0744L9.43493 8.00876C9.18014 7.75397 8.80896 7.65461 8.46084 7.74794C8.11273 7.84127 7.84091 8.11308 7.74794 8.46084C7.65461 8.80896 7.75433 9.18014 8.00876 9.43493L11.0744 12.5002L8.00876 15.5654C7.61771 15.9593 7.61877 16.5956 8.0116 16.988C8.40407 17.3809 9.04033 17.3819 9.43422 16.9909L12.5002 13.9256L15.5654 16.9912C15.9597 17.3823 16.5956 17.3812 16.988 16.9884C17.3805 16.5959 17.3819 15.9597 16.9905 15.5658L13.9256 12.5002L16.9912 9.43493C17.1804 9.24579 17.2868 8.98958 17.2868 8.72202C17.2868 8.45446 17.1807 8.1979 16.9912 8.00876Z" fill="#B9B9B9"/>
            </svg>
          </button>
        </div>
      </div>
    </Layout2>
    <DialogDef :show="addone" :label="'新增群組標籤'" :width="'711px'" @close="tag=null;addone=false">
      <div class="addonebox">
        <input type="text" :style="{width: '589px'}" :placeholder="'請輸入群組標籤名稱'" v-model="tag">
        <BtnsS :style="{flexDirection: 'row', display: 'flex'}"
        @save="adding" @cancel="tag=null;addone=false"/>
      </div>
    </DialogDef>
    <DialogDef :show="addmember" :label="'新增人員'" :width="'711px'" @close="addmember=false;memberText=null;ulShow=false;member=null;searchedUsers=[]">
      <div class="addonebox">
        <label class="addonelabel" v-if="!member">
          <input type="text" :style="{width: '589px'}" :placeholder="'請輸稱LINE名稱 / 暱稱 / 會員ID / 聯絡電話'" v-model="memberText">
          <div class="ul" v-if="ulShow">
            <div class="li" v-for="(us,u) in searchedUsers" :key="`searchedUsers-${u}`" @click="member=us">{{us.lineName}}  <span v-if="us.pause">(停用)</span></div>
          </div>
        </label>
        <div v-else class="memberSelect" :style="{display: 'flex', width: '589px', height: '70px', border: '1px solid #CACACA'}">
          <div>{{member.lineName}}  <span v-if="member.pause">(停用)</span></div>
          <button @click="member=null">
            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.5002 0C5.59644 0 0 5.59644 0 12.5002C0 19.4036 5.59644 25 12.5002 25C19.4036 25 25 19.4036 25 12.5002C24.9918 5.59999 19.4004 0.0081617 12.5002 0ZM12.5002 22.9841C6.70998 22.9841 2.01629 18.2904 2.01629 12.5002C2.01629 6.70998 6.70998 2.01629 12.5002 2.01629C18.29 2.01629 22.9841 6.70998 22.9841 12.5002C22.9773 18.2875 18.2875 22.9773 12.5002 22.9841ZM16.9912 8.00876C16.5977 7.61522 15.9593 7.61522 15.5658 8.00876L12.5002 11.0744L9.43493 8.00876C9.18014 7.75397 8.80896 7.65461 8.46084 7.74794C8.11273 7.84127 7.84091 8.11308 7.74794 8.46084C7.65461 8.80896 7.75433 9.18014 8.00876 9.43493L11.0744 12.5002L8.00876 15.5654C7.61771 15.9593 7.61877 16.5956 8.0116 16.988C8.40407 17.3809 9.04033 17.3819 9.43422 16.9909L12.5002 13.9256L15.5654 16.9912C15.9597 17.3823 16.5956 17.3812 16.988 16.9884C17.3805 16.5959 17.3819 15.9597 16.9905 15.5658L13.9256 12.5002L16.9912 9.43493C17.1804 9.24579 17.2868 8.98958 17.2868 8.72202C17.2868 8.45446 17.1807 8.1979 16.9912 8.00876Z" fill="#B9B9B9"/>
            </svg>
          </button>
        </div>
        <BtnsS @save="addMem" :style="{flexDirection: 'row', display: 'flex'}" @cancel="addmember=false;memberText=null;ulShow=false;member=null;searchedUsers=[]"/>
      </div>
    </DialogDef>
    <DialogDef :show="deleteTag" :label="'刪除群組標籤'" :width="'711px'" @close="deleteTag=null">
      <div class="deleteTag">
        <p :style="{fontSize: '24px'}">確定要刪除"{{deleteTag}}"標籤嗎?</p>
        <BtnsS @save="deleteTagfn" :style="{flexDirection: 'row', display: 'flex'}" @cancel="deleteTag=null"/>
      </div>
    </DialogDef>
  </Layout1>
</template>

<script>
import DialogDef from '../../../components/dialognoPadding2.vue'
import Layout1 from '../../../components/layout/L1.vue'
import Layout2 from '../../../components/layout/La1.vue'
import BtnsS from '../../../components/btn/btns.vue'
import XLSX from 'xlsx'
import SBtn from '../../../components/btn/sqr40016.vue'
import RBtn from '../../../components/btn/round.vue'
import { getapi, postapi } from '../../../store/fetch'
export default {
  components: {
    DialogDef,
    Layout1,
    Layout2,
    RBtn,
    SBtn,
    BtnsS
  },
  data () {
    return {
      tags: [],
      addone: false,
      addmember: false,
      tag: null,
      users: [],
      tagSelect: null,
      member: null,
      memberText: null,
      searchedUsers: [],
      ulShow: false,
      deleteTag: null
    }
  },
  async mounted () {
    // const tags = await getapi('selections/user-tags')
    const tags = await getapi('users/tagslist')
    this.tags = tags || []
    this.tagSelect = this.tags[0].options
  },
  watch: {
    async tagSelect () {
      await this.getusers()
    },
    async memberText () {
      if (this.memberText) {
        const { data } = await getapi('users/v2/all?' + new URLSearchParams(this.memberText ? { search: this.memberText } : {}))
        this.searchedUsers = data
        this.ulShow = true
      } else {
        this.searchedUsers = []
        this.ulShow = false
      }
    }
  },
  methods: {
    exporttofile () {
      const data = this.users.map(({ name, lineName, mobile }) => { return { 登錄姓名: name, 顯示名稱: lineName, 電話: mobile } })
      const workbook = XLSX.utils.book_new()
      const worksheet = XLSX.utils.json_to_sheet(data)
      XLSX.utils.book_append_sheet(workbook, worksheet, this.tagSelect)
      XLSX.writeFile(workbook, `${this.tagSelect}.xlsx`)
    },
    async removeOne (id) {
      await postapi(`users/v2/tags/${id}?` + new URLSearchParams({ tag: this.tagSelect, act: 'remove' }))
      const tags = await getapi('users/tagslist')
      this.tags = tags || []
      await this.getusers()
    },
    async addMem () {
      if (!this.member) {
        alert('沒有USER')
        return false
      }
      await postapi(`users/v2/tags/${this.member._id}?` + new URLSearchParams({ tag: this.tagSelect, act: 'add' }))
      await this.getusers()
      this.member = null
      this.memberText = null
      this.ulShow = false
      this.searchedUsers = []
      const tags = await getapi('users/tagslist')
      this.tags = tags || []
      this.addmember = false
    },
    async getusers () {
      this.users = await getapi('users/v2/tags?' + new URLSearchParams({ tags: [this.tagSelect] }))
    },
    async deleteTagfn () {
      const tags = JSON.parse(JSON.stringify(this.tags.map(e => e.options)))
      const index = tags.indexOf(this.deleteTag)
      if (this.tags[index].sum === 0) {
        tags.splice(index, 1)
        const r = await postapi('selections/user-tags', { key: 'options', data: tags.filter(e => e) })
        if (r) {
          this.tags.splice(index, 1)
          this.tag = null
          this.addone = false
          this.deleteTag = null
        }
      }
    },
    async adding () {
      const r = await postapi('selections/user-tags', { key: 'options', data: [...this.tags.map(e => e.options), this.tag].filter(e => e) })
      if (r) {
        this.tags.push({ options: this.tag, sum: 0 })
        this.tag = null
        this.addone = false
      }
    }
  }
}
</script>

<style lang="scss">
#tagsSetting {
  .La1_left {
    border-right: 1px solid #CACACA;
    display: grid;
    grid-template-rows: 1fr 85px;
  }
  .La1_right {
    padding: 15px 26px 0 56px ;
    display: flex;
    flex-direction: column;
    gap: 30px;
  }
}
</style>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.deleteTag {
  padding: 40px;
  gap: 20px;
  display: flex;
  flex-direction: column;
  height: fit-content;
}
.tagname {
  display: flex;
  align-items: center;
}
.num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  border-radius: 20px;
  width: 40px;
  height: 40px;
  color: #FFFFFF;
  background: var(--color-checked);
  &::before {
    content: attr(num);
  }
  &.nan:hover {
    &::before {
      content: '';
    }
    background-color: var(--highlight);
    mask-image: url(/svg/btn/del1.svg);
    mask-position: center;
    mask-border: 1px solid var(--color-checked);
    mask-repeat: no-repeat;
  }
}
.memberSelect {
  width: 589px;
  height: 70px;
  font-weight: 400;
  font-size: 22px;
  line-height: 32px;
  border: 1px solid #999999;
  text-align: center;
  letter-spacing: 0.1em;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  border-radius: 3px;
  position: relative;
  button {
    position: absolute;
    right: 25px;
    width: 25px;
    height: 25px;
    background-color: transparent;
    padding: 0;

  }
}
.addonelabel {
  height: 70px;
  width: 589px;
  position: relative;
  .ul {
    box-shadow: 3px 3px 4px rgba(0, 0, 0, 0.25);
    position: absolute;
    top: 70px;
    background-color: #FFFFFF;
    left: 0;
    right: 0;
    max-height: 300px;
    overflow-y: auto;
   .li {
      height: 50px;
      font-size: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover {
        background-color: var(--color-infobox);
      }
    }
  }
}
.userList {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 20px 30px;
  padding: 2px 2px 20px 2px;
  overflow-y: auto;
  &>div{
    text-align: start;
    width: 400px;
    height: 75px;
    background: #FFFFFF;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-inline: 25px;
    font-weight: 400;
    font-size: 20px;
    line-height: 29px;
    letter-spacing: 0.1em;
    color: #787878;
    button {
      background-color: transparent;
      width: 25px;
      height: 25px;
      padding: 0;
    }
  }
}
.titlea {
  display: flex;
  gap: 25px;
  align-items: center;
  font-weight: 500;
  font-size: 24px;
  line-height: 35px;
  letter-spacing: 0.1em;
  color: var(--color-pri);
}
.tagslist{
  display: flex;
  flex-direction: column;
  &>div{
    min-height: 70px;
    height: 70px;
    padding: 25px 30px;
    font-weight: 400;
    font-size: 20px;
    line-height: 150%;
    letter-spacing: 0.05em;
    color: var(--color-pri);
    text-align: start;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &:hover {
      background-color: var(--color-infobox);
    }
    &.selected {
      background-color: var(--color-infobox);
    }
  }
}
.addonebox {
  padding-block: 46px 43px;
  gap: 40px;
  display: flex;
  flex-direction: column;
  width: 711px;
  align-items: center;
  justify-content: flex-start;
  input[type=text] {
    width: 589px;
    height: 60px;
    font-weight: 400;
    font-size: 22px;
    line-height: 32px;
    border: 1px solid #999999;
    text-align: center;
    letter-spacing: 0.1em;
    border-radius: 5px;
    &::placeholder {
      color: #DADADA;
    }
  }
}
.tagslist {
  overflow-y: auto;
}
#tags-foot {
  margin-top: auto;
  border-top: 1px solid #CACACA;
  padding: 19px 22px;
  button {
    font-weight: 500;
    font-size: 16px;
    line-height: 170%;
    letter-spacing: 0.1em;
    color: var(--color-checked);
    width: 100%;
    height: 47px;
    background-color: transparent;
    border: 1px solid var(--color-checked);
    border-radius: 3px;
  }
}
</style>
